import React from 'react';
import styled from 'styled-components';
import { Col, Row } from 'tdesign-react';
import ShadowCard from '@/components/ShadowCard';
import SummaryBlock from '@/components/Cluster/SummaryBlock';

/**
 * @typedef {'topic' | 'subscription' | 'consumer' | 'producer' | 'other1' | 'other2' | 'other3' | 'other4','other5'} iconEnum
 */

/**
 *
 * @param {Object} props
 * @param {string} props.img 右侧图片
 * @param {Object[]} props.items
 * @param {string} props.items.title
 * @param {string} props.items.value
 * @param {string} [props.items.tip] 问号提示
 * @param {string} [props.items.unit] 单位
 * @param {iconEnum} [props.items.icon] 单位
 * @param {boolean} [props.shadow] 是否阴影卡片
 * @returns
 */
export default function SummaryPanel({ img, items = [], prepend, shadow, ...others }) {
  const node = (
    <>
      <Row gutter={12} style={{ flex: 1 }}>
        {prepend}

        {items.map((item, index) => (
          <Col style={{ width: 0 }} flex={1} key={index}>
            {React.isValidElement(item) ? item : <SummaryBlock {...item} />}
          </Col>
        ))}
      </Row>
      {img && <Bg src={img} />}
    </>
  );
  return shadow ? <Root {...others}>{node}</Root> : <div {...others}>{node}</div>;
}

const Root = styled(ShadowCard)`
  .shadow-card-body {
    padding: 10px 24px 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
`;

const Bg = styled.img`
  width: 80px;
  height: 80px;
  margin-left: 24px;
`;
